// removed by extract-text-webpack-plugin
module.exports = {"structure":"RoleDetails-structure"};